import { render, staticRenderFns } from "./PortalColumnManagement.vue?vue&type=template&id=8d35ad54&scoped=true"
import script from "./PortalColumnManagement.vue?vue&type=script&lang=js"
export * from "./PortalColumnManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d35ad54",
  null
  
)

export default component.exports